import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { ExpectedEnergyLossComponent } from "../../../../shared/widgets/expected-energy-loss/expected-energy-loss.component";
import { BarChartComponent } from "../widgets/bar-chart/bar-chart.component";
import { LineChartComponent } from "../widgets/line-chart/line-chart.component";
import { DoughnutChartComponent } from "../widgets/doughnut-chart/doughnut-chart.component";
import { ActivatedRoute } from "@angular/router";
import { ASSET_TYPES } from "../../../../enums/assetTypes.enum";

import { ChartChangeTimeEvent } from "../../../../models/ui/chartData";
import { SimplebarAngularModule } from "simplebar-angular";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { CustomerEnergyToolService } from "./facade/customer-energy-tool.service";
import { EnergyExportComponent } from "../widgets/energy-export/energy-export.component";

@Component({
  standalone: true,
  selector: "app-customer-energy",
  imports: [
    ExpectedEnergyLossComponent,
    BarChartComponent,
    LineChartComponent,
    DoughnutChartComponent,
    SimplebarAngularModule,
    EnergyExportComponent,
  ],
  templateUrl: "./customer-energy.component.html",
  styleUrl: "./customer-energy.component.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [CustomerEnergyToolService],
})
export class CustomerEnergyComponent {
  private route = inject(ActivatedRoute);
  public sourceType = ASSET_TYPES.CUSTOMER;
  public sourceId!: string;
  public energyToolFacade = inject(CustomerEnergyToolService);

  constructor() {
    this.route.url.pipe(takeUntilDestroyed()).subscribe((url) => {
      this.sourceId = url[1].path;
      this.energyToolFacade.loadInitialState(this.sourceId);
    });
  }

  /**
   * Handler for time range change events emitted by the doughnut chart.
   * @param changeEvent The new time range chosen by the user.
   */
  public onChangeTimeDoughnutChart(changeEvent: string) {
    this.energyToolFacade.updateDoughnutChartForTimeRange(this.sourceId, changeEvent);
  }

  /**
   * Handler for time range change events emitted by the bar chart.
   * @param changeEvent The new time range chosen by the user.
   */
  public onChangeTimeBarChart(changeEvent: ChartChangeTimeEvent) {
    this.energyToolFacade.updateBarChartForTimeRange(
      changeEvent.start,
      changeEvent.end,
      changeEvent.timeFrame,
      this.sourceId,
      changeEvent.assetLabels?.[0]
    );
  }

  /**
   * Handler for time range change events emitted by the line chart.
   * @param changeEvent The new time range chosen by the user.
   */
  public onChangeTimeLineChart(changeEvent: ChartChangeTimeEvent) {
    this.energyToolFacade.updateLineChartForTimeRange(
      changeEvent.start,
      changeEvent.end,
      changeEvent.timeFrame,
      this.sourceId
    );
  }

  /**
   * Handler for time range change events emitted by the expected energy loss widget.
   * @param changeEvent The new time range chosen by the user.
   */
  public onChangeTimeExpecteEnergyLoss(changeEvent: string) {
    this.energyToolFacade.updateEnergyLossForTimeWindow(this.sourceId, changeEvent);
  }
}
